import { DatePipe } from '@angular/common';
import { etiquetaVaca, rpVaca } from '@shared/utils/etiqueta-vaca';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { MatIcon } from '@angular/material/icon';
// import { MatTooltip } from '@angular/material/tooltip';
import {
  DataTable,
  FilterOption,
  FilterSelect,
  FiltersContainer,
  TableCellDirective,
  TableColumn,
} from '@shared/components/ui/list-components';
import { ErrorService } from '@shared/services/error.service';
import { AuthenticationService } from '@core/auth/authentication.service';
import { PageHeaderComponent } from '@shared/components/common/page-header/page-header.component';

import { Cliente } from '../../crm/clientes/clientes.interface';
import { EmbrionesService } from '../embriones/embriones.service';
import { EmbrionFresco } from './frescos.interface';
import { FrescosService } from './frescos.service';

@Component({
  selector: 'app-stock-embriones-frescos',
  imports: [
    DataTable,
    DatePipe,
    FilterSelect,
    FiltersContainer,
    // MatIcon,
    // MatTooltip,
    PageHeaderComponent,
    TableCellDirective,
  ],
  templateUrl: './stock-embriones-frescos.html',
})
export class StockEmbrionesFrescos implements OnInit {
  /** La vaca se identifica por su RP, como en la caravana. */
  readonly etiquetaVaca = etiquetaVaca;
  readonly rpVaca = rpVaca;

  loading = false;
  frescos: EmbrionFresco[] = [];
  clientes: Cliente[] = [];
  clienteId = '';
  /** Por defecto solo lo transferible; los agotados se ven cambiando el filtro. */
  soloDisponibles = 'true';

  columns: TableColumn[] = [
    { key: 'cliente', header: 'Cliente' },
    { key: 'donante', header: 'Donante' },
    { key: 'toro', header: 'Toro' },
    // { key: 'tecnica', header: 'Técnica' },
    { key: 'fecha_salida', header: 'Fecha de producción' },
    { key: 'fecha_transferencia', header: 'Fecha de transferencia' },
    { key: 'transferido_a', header: 'Transferido a' },
    { key: 'embriones', header: 'Embriones' },
    // { key: 'acciones', header: 'Acciones' },
  ];

  readonly disponibilidadOptions: FilterOption[] = [
    { value: 'true', label: 'Solo disponibles' },
    { value: 'false', label: 'Todos' },
  ];

  get clientesOptions(): FilterOption[] {
    return this.clientes.map(cliente => ({ value: cliente.id, label: cliente.persona.nombre_generico }));
  }

  private frescosService = inject(FrescosService);
  private embrionesService = inject(EmbrionesService);
  private errorService = inject(ErrorService);
  private router = inject(Router);
  readonly auth = inject(AuthenticationService);

  ngOnInit(): void {
    // Un usuario atado a un cliente ya recibe solo lo suyo: no hay qué elegir.
    if (!this.auth.clienteDelUsuario()) {
      this.loadClientes();
    }
    this.getFrescos();
  }

  loadClientes(): void {
    this.embrionesService.comboClientes().subscribe({
      next: (response) => {
        if (response.status) {
          this.clientes = response.data;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error);
      },
    });
  }

  getFrescos(): void {
    this.loading = true;

    this.frescosService.index({
      cli_cliente_id: this.clienteId ? Number(this.clienteId) : undefined,
      solo_disponibles: this.soloDisponibles === 'true',
    }).subscribe({
      next: (response) => {
        if (response.status && response.data) {
          this.frescos = response.data;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error);
      },
    }).add(() => {
      this.loading = false;
    });
  }

  onClienteChange(value: string | number): void {
    this.clienteId = String(value);
    this.getFrescos();
  }

  onDisponibilidadChange(value: string | number): void {
    this.soloDisponibles = String(value);
    this.getFrescos();
  }

  get hasActiveFilters(): boolean {
    return !!this.clienteId || this.soloDisponibles !== 'true';
  }

  clearFilters(): void {
    this.clienteId = '';
    this.soloDisponibles = 'true';
    this.getFrescos();
  }

  /** El fresco no tiene detalle propio: su ficha es el cultivo que lo produjo. */
  verCultivoOrigen(fresco: EmbrionFresco): void {
    if (!fresco.lab_agendamiento_opu_id) {
      return;
    }

    this.router.navigate([
      '/pive',
      fresco.lab_agendamiento_opu_id,
      'cultivos',
      fresco.lab_cultivo_embrionario_id,
    ]);
  }
}
